import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import {
  ArrowUpRightBlue,
  BackwardArrow,
  ForwardArrow,
  left_arrow,
} from "../../../../constant/imagePath";
import { AfterLoginHeader } from "../../../../stories/AfterLoginHeader/AfterLoginHeader";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { DashboardBookingDetailCard } from "../../../../stories/DashboardBookingDetailCard/DashboardBookingDetailCard";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Footer } from "../../../../stories/Footer/Footer";
import PaymentMethodCard from "../../../../stories/PaymentMethodCard/PaymentMethodCard";
import classes from "./performanceEvaluation.module.css";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import PerformanceEvaluationMobile from "./PerformanceEvaluationMobile";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { Button } from "../../../../stories/Button/Button";
import UpdatedModal from '../../../../components/Modals/StudentFlow/Dashboard/UpdatedModal/UpdatedModal'

function PerformanceEvaluationDesktop() {
  const history = useHistory();
  const location = useLocation();
  const [feedback, setFeedback] = useState('Vitae fames a consectetur ut adipiscing vestibulum, auctor donec facilisi. Arcu sed facilisi egestas facilisi cras egestas mauris aenean nisl. Massa, leo felis, vel donec morbi dignissim bibendum a ac. Sit mi, magna semper ut. Congue justo, sapien duis dui suspendisse.Vitae fames a consectetur ut adipiscing vestibulum, auctor donec facilisi. Arcu sed facilisi egestas facilisi cras egestas mauris aenean nisl. Massa, leo felis, vel donec morbi dignissim bibendum a ac. Sit mi, magna semper ut. Congue justo, sapien duis dui suspendisse.')
  const [isUpdating, setIsUpdating] = useState(false)
  const [isUpdated, setIsUpdated] = useState(false)
  // const [data, setData] = useState();
  const type = location?.state?.type;
  // const type = "completed";


  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <AfterLoginHeader showSearch />
      </div>
      <Container fluid className={classes.container}>
        <Row className="gx-5">
          <Col xl={7} lg={6} xxl={8}>
            <Row className="g-0">
              <Col
                md={12}
                className={`${[classes.pb32, classes.borderBtm].join(" ")}`}
              >
                <LinkButtonWithIcon
                  primary={false}
                  leftIcon={BackwardArrow}
                  text={"Go Back"}
                  onClick={() => history.goBack()}
                />
                <h3
                  style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                  className={classes.mt16}
                >
                  1-on-1 Tennis Lesson with Michael Baumgardner
                </h3>
              </Col>
              <Col
                md={12}
                className={`${[
                  classes.mt32,
                  classes.pb32,
                  classes.borderBtm,
                ].join(" ")}`}
              >
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Performance evaluation
                </h5>
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                  className={classes.mt16}
                >
                  Vitae fames a consectetur ut adipiscing vestibulum, auctor
                  donec facilisi. Arcu sed facilisi egestas facilisi cras
                  egestas mauris aenean nisl. Massa, leo felis, vel donec morbi
                  dignissim bibendum a ac.
                </p>
              </Col>
              <Col md={12} className={classes.mt32}>
                <h5 style={{ ...Fonts.h5 }} className={classes.mb16}>Your’s feedback of the lesson</h5>
                {isUpdated ?
                  <div className={classes.feedbackBox} style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}>
                    <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>{feedback}</p>
                  </div>
                  :
                  <TextArea state={feedback} setter={setFeedback} disabled={isUpdated} />}
                {!isUpdated && <div className={[classes.mt16, classes.btnsBox].join(" ")}>
                  <Button label={'Cancel'} primary={false} size={'Medium'} customStyle={{ width: 'max-content', padding: '14px 50px' }} />
                  <Button label={'Update'} primary={true} size={'Medium'} customStyle={{ width: 'max-content', padding: '14px 48.2px', marginLeft: '8px' }} onClick={() => {
                    setIsUpdating(true)
                    setTimeout(() => {
                      setIsUpdated(true)
                      setIsUpdating(false)
                    }, 2000)

                  }} />
                </div>}
              </Col>
              <Col md={12} className={classes.mt64}>
                <PaymentMethodCard
                  data={{
                    type: "master",
                    title: "Paid with card ending",
                    number: ".... 0084",
                    description: "This is your default payment method",
                    date: "Aug 12, 2021",
                    time: "02:06pm",
                    amount: "75",
                  }}
                  isDone={true}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={5} lg={6} xxl={4}>
            <DashboardBookingDetailCard />
          </Col>
        </Row>
      </Container>
      <div className={classes.footer}>
        <Footer />
      </div>
      <UpdatedModal show={isUpdating} setShow={setIsUpdating} />
    </div>
  );
}

function PerformanceEvaluation() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  return isMobile ? (
    <PerformanceEvaluationMobile />
  ) : (
    <PerformanceEvaluationDesktop />
  );
}

export default PerformanceEvaluation;
